import { printAST } from '@utils/ast';
import { video23AudioToLatexPrinters } from './spec.23video.audio.js';
import { video23ToLatexPrinters } from './spec.23video.video.js';
import { boxToLatexPrinters } from './spec.box.js';
import { fontToLatexPrinters } from './spec.font.js';
import { iGuideHtmlNodeLatexPrinters } from './spec.html.js';
import { imageToLatexPrinters } from './spec.image.js';
import { linkToLatexPrinters } from './spec.link.js';
import { medialibraryToLatexPrinters } from './spec.medialibrary.js';
import { iGuideHtmlToAst } from './util.html-to-ast.js';

function convertIGuideHtmlToLatex(html, options) {
  const ast = iGuideHtmlToAst(html, options);
  return printAST(ast, {
    ...iGuideHtmlNodeLatexPrinters,
    ...fontToLatexPrinters,
    ...boxToLatexPrinters,
    ...video23ToLatexPrinters,
    ...video23AudioToLatexPrinters,
    ...medialibraryToLatexPrinters,
    ...imageToLatexPrinters,
    ...linkToLatexPrinters
  }).join("\n");
}

export { convertIGuideHtmlToLatex };
//# sourceMappingURL=util.html-to-latex.js.map
